import {InjectionToken} from '@angular/core';
import {Params} from '@angular/router';
import {Observable} from 'rxjs';

export class BreadCrumb {
    title?: string;
    type?: string;
    id?: string;
    link?: string;
    icon?: string;
    tooltip?: string;
    queryParam?: Params;
}

export interface MxTitleAndBreadcrumbsService {
    setTitle(title: string): void;
    getBreadcrumbObsr(): Observable<Array<BreadCrumb>>;
}

export const MX_TITLE_SERVICE_TOKEN = new InjectionToken<MxTitleAndBreadcrumbsService>('MX_TITLE_SERVICE_TOKEN');

